import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { tabs } from './tab'
import { Tabs } from 'vnetwork-ui'

const List = () => {
    const { t } = useTranslation()
    const { TabComponent, TabProps } = useTabs({
        tabs: tabs(t),
        clearFilters: true,
    })

    return (
        <div className="">
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.invoices,
                        title: t('invoices'),
                    },
                ]}
            />
            <div className="space-y-2">
                <Tabs {...TabProps} />
                {TabComponent}
            </div>
        </div>
    )
}

export default List
